<p-overlayPanel
  [appendTo]="'body'"
  #draftsPanel
  [style]="{
    overflow: 'auto',
    maxHeight: '500px',
  }"
>
  <div class="header">
    <ly-icon icon="addFile"></ly-icon>
    <h4>Lonely Doddles</h4>
  </div>
  <div
    class="flex flex-column gap-3 w-15rem draft-list"
    pDroppable
    (onDrop)="onDrop()"
  >
    @for (draft of drafts; track $index) {
      <ly-post
        pDraggable
        (onDrag)="onDragging()"
        (onDragStart)="onDragStart(draft)"
        mode="list"
        [doddle]="draft"
      ></ly-post>
    } @empty {
      <div class="empty-state">
        <h4>No Doddles here… yet!</h4>
        <p>
          Welcome to the home of Lonely Doddles - posts without a date,
          uninvited to calendars 😢
        </p>
      </div>
    }
  </div>
</p-overlayPanel>
